import React, { useEffect, useState } from 'react'
import DataTable1 from '~/Common-Objects/Tables/DataTable1/DataTable1'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Toggle from '~/Common-Objects/UI/Forms/Toggle/Toggle'
import UilibIcon from '~/Common-Objects/UI/Icon'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { handleGenericError, alterSnackbar } from '~/data/actions/siteActions'
import axios from '~/data/http/axios'
import Button from '../../components/button'
import TextInput from '../../components/textInput'
import Header from '../../components/header'
import i18n from '~/i18n'

export default function InboxSentiment({ inbox, loadInbox = () => {} }) {
    const dispatch = useDispatch()
    const history = useHistory()
    const [settings, setSettings] = useState(inbox.settings ? JSON.parse(JSON.stringify(inbox.settings)) : {})
    const [channels, setChannels] = useState()

    const save = async () => {
        await axios.put(`/inboxes/${inbox.id}`, {
            settings: settings
        })
        await loadInbox()
        dispatch(alterSnackbar(true, i18n.t('chat:settings.sentiment.saved')))
    }

    const toggle = (id) => {
        const _settings = JSON.parse(JSON.stringify(settings))
        if (!_settings.sentimentAnalysis) _settings.sentimentAnalysis = []
        const index = _settings.sentimentAnalysis.indexOf(id)
        if (index > -1) {
            _settings.sentimentAnalysis.splice(index, 1)
        } else {
            _settings.sentimentAnalysis.push(id)
        }
        setSettings(_settings)
    }

    async function loadChannels() {
        try {
            const { data } = await axios.get(`/inboxes/${inbox.id}/channel`)
            setChannels(data)
        } catch (error) {
            dispatch(handleGenericError(error))
            throw error
        }
    }

    useEffect(() => {
        loadChannels()
    }, [])

    if (!channels) return <LoadingIcons noClass />

    const data = channels.map((channel) => {
        const enabled = settings?.sentimentAnalysis?.indexOf(channel.id) > -1
        return {
            icons: {
                headerValue: ' ',
                value: (
                    <Icon
                        type={channel.type}
                        style={{ color: 'var(--neutral-500)', height: 20, width: 20, maringLeft: 4 }}
                    />
                ),
                width: 40
            },
            channel: {
                headerValue: i18n.t('chat:settings.sentiment.channel'),
                value: channel.name
            },
            options: {
                headerValue: ' ',
                align: 'right',
                value: (
                    <Toggle
                        checked={enabled}
                        after={
                            enabled
                                ? i18n.t('chat:settings.sentiment.enabled')
                                : i18n.t('chat:settings.sentiment.disabled')
                        }
                        onChange={() => toggle(channel.id)}
                    />
                )
            }
        }
    })

    return (
        <div className='col-xs-12 col-sm-12 col-md-8 col-lg-6 inbox_settings_left_content'>
            <Header type='inbox' option='sentiment' />

            <form>
                <DataTable1 tableData={data} />

                <Button className='mar-t10' size='s' onClick={save}>
                    Save Sentiment Settings
                </Button>
            </form>
        </div>
    )
}

function Icon({ type, ...rest }) {
    let icon

    switch (type) {
        case 1:
            icon = 'mail-open'
            break
        case 2:
            icon = 'chat'
            break
        case 3:
            icon = 'facebook'
            break
    }

    return <UilibIcon name={icon} {...rest} />
}
